import state from "./moduleGridMapState.js";
import mutations from "./moduleGridMapMutations.js";
import actions from "./moduleGridMapActions.js";
import getters from "./moduleGridMapGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
